import {resolveGoogExport} from 'dgetz/tsclj'

// ;; BMI = (lbs/2.2)/((inches*0.0254)^2
export function inchesLbsToBmi(inches, lbs) { // AI port
    let inches_lbs__GT_bmi = resolveGoogExport('ladder.common.inches_lbs__GT_bmi');
    return inches_lbs__GT_bmi(inches, lbs); // annoying port
    //const meters = new BigNumber(inches).times(M(0.0254)); // M ?
    //const denom = meters.times(meters).times(M(2.2));
    //return div(lbs, denom, { decimalPlaces: 2 }); -- `div` is annoying to port, many type flags, vendored dep
}

export function fmtMoneyNoRoundNoWord(n, decimals = null) {
    const {fmt_money_no_round_no_word} = resolveGoogExport('ladder.common')
    if (decimals == null) {
        return fmt_money_no_round_no_word(n)
    } else {
        return fmt_money_no_round_no_word(n, decimals)
    }
}

export function fmtMoneyNoRound(n) {
    const {fmt_money_no_round} = resolveGoogExport('ladder.common')
    return fmt_money_no_round(n)
}

export function typingPhoneFmt(s: string, old: string = '') {
    let {typing_phone_fmt} = resolveGoogExport('ladder.common')
    return typing_phone_fmt(s, old)
}
